import { CommonModule } from '@angular/common';
import { Component, forwardRef, OnInit, inject } from '@angular/core';
import {
   ControlContainer,
   ControlValueAccessor,
   FormGroup,
   FormGroupDirective,
   NG_VALUE_ACCESSOR,
   NgControl,
} from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

@Component({
   selector: 'app-phone-mockup',
   standalone: true,
   imports: [CommonModule, TranslateModule],
   viewProviders: [
      {
         provide: ControlContainer,
         useExisting: FormGroupDirective,
      },
      {
         provide: NG_VALUE_ACCESSOR,
         multi: true,
         useExisting: forwardRef(() => PhoneMockupComponent),
      },
   ],
   templateUrl: './phone-mockup.component.html',
   styleUrl: './phone-mockup.component.scss',
})
export class PhoneMockupComponent implements OnInit, ControlValueAccessor {
   private parent = inject(FormGroupDirective);
   ngControl = inject(NgControl, { optional: true, self: true })!;

   form: FormGroup = new FormGroup({});

   get f() {
      return this.form.controls;
   }

   /** Inserted by Angular inject() migration for backwards compatibility */
   constructor(...args: unknown[]);

   constructor() {
      if (this.ngControl != null) this.ngControl.valueAccessor = this;
   }

   writeValue(value: any): void {}

   onChange: (_: any) => void = (value: any) => {};

   onTouched: () => void = () => {};

   registerOnChange(fn: any): void {
      this.onChange = fn;
   }

   registerOnTouched(fn: any): void {
      this.onTouched = fn;
   }

   ngOnInit() {
      this.form = this.parent.form;
   }
}
